<template>
  <div
    class="tasks"
    :class="{ 'tasks_empty': tasksAvailable && selectedTab === 0 && availableItems.length === 0 }"
  >
    <div v-if="!isMobileApp" class="divider"></div>
    <div v-if="!isMobileApp" class="tasks__menu">
      <Menu />
      <div class="divider"></div>
    </div>

    <SettingUpGuide
      v-bind="settingUpGuideOptions"
      :href="articleAboutTasks"
      :state="bannerAboutTasks"
      @hide="bannerAboutTasksClose()"
    />

    <div class="tasks__tabs">
      <Tabs
        v-if="!loading"
        :items="[getTabText(0), getTabText(1), getTabText(2)]"
        :activeItem="selectedTab"
        @changed="changeTab($event)"
      />
    </div>

    <div v-if="showTaskFilters && selectedTab === 0" class="divider"></div>
    <Filters
      v-if="showTaskFilters && isFiltersLoaded && selectedTab === 0 && ((!hasActiveFilters && availableItems.length !== 0) || hasActiveFilters)"
      :options="filters"
      :hideDropdown="hideFiltersDropdown"
      @change="onFilterChange"
      @reset="onFilterReset"
    />

    <div class="tasks__items">
      <div v-if="tasksAvailable" v-show="selectedTab === 0 && availableItems.length > 0">
        <TaskCard
          v-for="(task, i) in availableItems"
          :key="task.exerciseId || i"
          :stateLabels="stateLabels"
          :timeLabels="timeLabels"
          :styleLabels="styleLabels"
          :image="task.images && task.images.mobile"
          :action="{ func: () => onShowTask(i) }"
          type="coins"
          state="available"
          :title="task.title"
          :subtitle="task.shortDescription"
          :cost="getTaskRewardRange(task)"
          :date="task.endDate"
          :itemsTotal="0"
          :itemsDone="0"
          :complexity="task.complexity"
          :isSpecial="task.isSpecial || false"
          :isDaily="task.isDaily || false"
          :isRepeat="false"
          :disciplines="disciplineIcon(task)"
          :chainsCount="task.exerciseChainInfo && task.exerciseChainInfo.countLinksTotal ? task.exerciseChainInfo.countLinksTotal : 0"
          :class="{
            'task--chain': task.exerciseChainInfo && task.exerciseChainInfo.countLinksTotal > 0
          }"
        ></TaskCard>
      </div>
      <div v-if="tasksAvailable && tasksAvailable.values.length === 0" v-show="selectedTab === 0 && availableItems.length === 0">
        <div class="tasks__empty">
          <div class="empty__img"><img :src="onTheWayRafiki" /></div>
          <div class="empty__title" v-html="emptyMessages[emptyState] ? emptyMessages[emptyState].title : ''"></div>
          <div class="empty__subtitle" v-html="emptyMessages[emptyState] ? emptyMessages[emptyState].subtitle : ''"></div>
        </div>
      </div>
      <div v-show="selectedTab === 1">
        <TaskCard
          v-for="(task, i) in inProgressItems"
          :key="task.exerciseId || task.exerciseChainId"
          :stateLabels="stateLabels"
          :timeLabels="timeLabels"
          :styleLabels="styleLabels"
          :image="task.images && task.images.mobile"
          :action="{ func: () => onShowTask(i) }"
          type="coins"
          state="inProgress"
          :title="task.title"
          :subtitle="task.shortDescription"
          :cost="getTaskRewardRange(task)"
          :date="task.endDate"
          :itemsTotal="getItemsTotal(task)"
          :itemsDone="getItemsDone(task)"
          :complexity="task.complexity"
          :isSpecial="task.isSpecial || false"
          :isDaily="task.isDaily || false"
          :isRepeat="false"
          :disciplines="disciplineIcon(task)"
          :chainsCount="task.exerciseChainInfo && task.exerciseChainInfo.participantExerciseChain && task.exerciseChainInfo.participantExerciseChain.countLinksTotal ? task.exerciseChainInfo.participantExerciseChain.countLinksTotal : (task.exerciseChainInfo && task.exerciseChainInfo.countLinksTotal ? task.exerciseChainInfo.countLinksTotal : 0)"
          :class="{
            'task--chain': task.exerciseChainInfo && task.exerciseChainInfo.participantExerciseChain && task.exerciseChainInfo.participantExerciseChain.countLinksTotal > 0
          }"
        />
      </div>
      <div v-if="tasksCompleted" v-show="selectedTab === 2">
        <TaskCard
          v-for="(task, i) in completedItems"
          :key="task.exerciseId || i"
          :stateLabels="stateLabels"
          :timeLabels="timeLabels"
          :styleLabels="styleLabels"
          :image="task.images && task.images.mobile"
          :action="{ func: () => onShowTask(i) }"
          type="coins"
          :state="getCompletedTaskState(task)"
          :title="task.title"
          :subtitle="task.shortDescription"
          :cost="getCompletedTaskCost(task)"
          :date="getCompletedTaskDate(task)"
          :itemsTotal="getItemsTotal(task)"
          :itemsDone="getItemsDone(task)"
          :complexity="task.complexity"
          :isSpecial="task.isSpecial || false"
          :isDaily="task.isDaily || false"
          :isRepeat="false"
          :disciplines="disciplineIcon(task)"
          :chainsCount="task.exerciseChainInfo && task.exerciseChainInfo.participantExerciseChain && task.exerciseChainInfo.participantExerciseChain.countLinksTotal ? task.exerciseChainInfo.participantExerciseChain.countLinksTotal : (task.exerciseChainInfo && task.exerciseChainInfo.countLinksTotal ? task.exerciseChainInfo.countLinksTotal : 0)"
          :class="{
            'task--chain': task.exerciseChainInfo && task.exerciseChainInfo.participantExerciseChain && task.exerciseChainInfo.participantExerciseChain.countLinksTotal > 0
          }"
        ></TaskCard>
      </div>
      <div class="tasks__loader" v-if="updating">
        <Loader size="24" />
      </div>
    </div>

    <div class="tasks__ambassador" v-show="selectedTab === 1">
      <Ambassador
        v-if="ambassadors && ambassadors.length > 0"
        :type="ambassadorsType || 'general'"
        :title="ambassadorsTitle"
        :items="ambassadorsValues"
      ></Ambassador>
    </div>

    <div class="tasks__loader-block"></div>

    <TaskDetailsModal
      :active="taskDetailsModal"
      :state="taskDetailsState"
      :modalOptions="taskDetailsOptions"
      :rating="taskRating"
      :openedFromChain="openedFromChain"
      @close="onTaskDetailsClose"
      @start="onStart"
    >
    </TaskDetailsModal>

    <ChainTaskDetailsModal
      :active="chainTaskDetailsModal"
      :state="taskDetailsState"
      :data="taskDetailsOptions"
      :rating="taskRating"
      @close="onChainTaskDetailsClose()"
      @start="onStartChain"
      @showChainTask="onShowChainTask"
      @openActiveChain="onOpenActiveChain"
      @chainCancelled="onChainCancelled"
    >
    </ChainTaskDetailsModal>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TaskCard from '@sc-component-library/task-card/src/main';
import Ambassador from '@sc-component-library/ambassador/src/main';
import dayjs from 'dayjs';
import { getArticleByKey } from '@/assets/js/helpers';
import Menu from '@/components/Menu/Menu.vue';
import TaskDetailsModal from '@/components/TaskDetailsModal/TaskDetailsModal.vue';
import ChainTaskDetailsModal from '@/components/ChainTaskDetailsModal/ChainTaskDetailsModal.vue';
import Filters from '@/components/Filters/Filters.vue';
import SettingUpGuide from '@/components/SettingUpGuide/SettingUpGuide.vue';

const { v4: uuidv4 } = require('uuid');

export default {
  name: 'Tasks',
  components: {
    TaskCard,
    Ambassador,
    Menu,
    TaskDetailsModal,
    ChainTaskDetailsModal,
    Filters,
    SettingUpGuide,
  },
  data() {
    return {
      disciplinesData: ['walking', 'running', 'swimming', 'cycling'],
      selectedTab: 0,
      stateLabels: {
        available: 'до ', inProgress: 'Выполняется', checking: 'Проверяется', completed: 'Выполнено', failed: 'Вы не успели :(',
      },
      styleLabels: {
        special: 'Особое задание', daily: 'Ежедневное', repeat: 'Многоразовое',
      },
      timeLabels: { days: 'д', hours: 'ч' },
      loading: false,
      updating: false,
      initialLoadCompleted: false,
      availableItems: [],
      inProgressItems: [],
      completedItems: [],
      offsetAvailable: 0,
      offsetInProgress: 0,
      offsetCompleted: 0,
      taskDetailsModal: false,
      chainTaskDetailsModal: false,
      taskDetailsOptions: {},
      taskDetailsState: 'available',
      taskDetailsExerciseId: '',
      pageScrollY: 0,
      loaderBlock: null,
      disciplineNames: [
        { id: 'Running', name: 'Тренировки - бег', order: 1 },
        { id: 'Walking', name: 'Тренировки - ходьба', order: 2 },
        { id: 'Cycling', name: 'Тренировки - вело', order: 3 },
        { id: 'Swimming', name: 'Тренировки - плавание', order: 4 },
        { id: 'Skiing', name: 'Тренировки - лыжи', order: 5 },
        {
          id: 'PartnerLink', name: 'Сообщество', order: 6, group: 'Partner',
        },
        {
          id: 'UploadImage', name: 'Сообщество', order: 7, group: 'Partner',
        },
        { id: 'GeoLocation', name: 'Посети объект', order: 8 },
        { id: 'Invite', name: 'Пригласи друга', order: 9 },
        { id: 'Quiz', name: 'Тесты', order: 10 },
        { id: 'Registration', name: 'Регистрация на событие', order: 11 },
        { id: 'Participation', name: 'Участие в событии', order: 12 },
        { id: 'Survey', name: 'Опрос', order: 13 },
        { id: 'Steps', name: 'Шаги', order: 14 },
        { id: 'Strength', name: 'Силовые тренировки', order: 15 },
        { id: 'Fitness', name: 'Гибкость и контроль', order: 16 },
        { id: 'MartialArts', name: 'Боевые искусства', order: 17 },
        { id: 'Dancing', name: 'Танцы', order: 18 },
        { id: 'Playing', name: 'Игровые виды спорта', order: 19 },
        { id: 'Extreme', name: 'Экстремальные и outdoor-активности', order: 20 },
        { id: 'Outdoor', name: 'Свободная тренировка', order: 21 },
      ],
      filters: {
        discipline: [],
      },
      availableFilters: {
        discipline: [],
      },
      activeFilters: {},
      isFiltersLoaded: false,
      hideFiltersDropdown: false,
      emptyMessages: {
        unfilteredEmpty: {
          title: 'Ого, вы взяли все задания!',
          subtitle: 'Желаем удачи в выполнении ваших амбициозных планов',
        },
        filteredEmpty: {
          title: 'Задания не найдены',
          subtitle: 'Попробуйте изменить или отключить фильтры',
        },
      },
      settingUpGuideOptions: {
        icon: 'question',
        text: 'Узнайте какие бывают задания и как копить баллы быстрее',
        actionText: 'Узнать больше',
        actionIcon: 'externa-link',
        storageKey: 'hideTasksBanner',
        view: 'default',
      },
      taskRating: {},
      registrationParticipant: {},
      bannerAboutTasks: true,
      dateValue: null,
      isLongCountDown: false,
      openedFromChain: false, // Флаг для отслеживания открытия задания из цепочки
      savedChainData: null, // Сохраняем данные цепочки
      lastProcessedHash: '', // Защита от повторной обработки hash
      hashProcessedAfterLoad: false, // Флаг для отслеживания обработки хэша после загрузки
    };
  },
  computed: {
    ...mapGetters('settings', ['options', 'resources']),
    ...mapGetters('user', ['isAuthenticated', 'isMobileApp']),
    ...mapGetters('trackers', ['trackers', 'responseStatus']),
    ...mapGetters('exercises', ['taskPoints', 'tasksAvailable', 'tasksInProgress', 'tasksCompleted', 'task', 'taskGuest', 'disciplines', 'responseStatus', 'chain', 'chainParticipants']),
    ...mapGetters('partners', ['registration']),
    ...mapGetters('content', ['ambassadors', 'contentStatus', 'articles']),
    routeName() {
      return this.$route.name;
    },
    showTaskFilters() {
      return this.options ? this.options.showTaskFilters === true : false;
    },
    enabledTaskFilters() {
      return this.options ? this.options.enabledTaskFilters || [] : [];
    },
    onTheWayRafiki() {
      return this.resources ? this.resources.onTheWayRafiki || '' : '';
    },
    articleAboutTasks() {
      const link = getArticleByKey(this.articles, 'key_4');
      return link || '#';
    },
    hasActiveFilters() {
      return Object.keys(this.activeFilters).length > 0;
    },
    emptyState() {
      if (this.hasActiveFilters) return 'filteredEmpty';
      return 'unfilteredEmpty';
    },
    countdownText() {
      const endDate = this.taskDetailsOptions?.participantExerciseChain?.endDate;
      if (!endDate) return '';
      const seconds = dayjs.utc(endDate).diff(dayjs.utc(), 'seconds');
      if (seconds <= 0) return '00:00:00';
      return this.formatCountdown(seconds);
    },
    ambassadorsType() {
      return this.options ? this.options.ambassadorsType || '' : 'general';
    },
    ambassadorsTitle() {
      return this.resources ? this.resources.ambassadorsTitle || '' : '';
    },
    ambassadorsValues() {
      return this.ambassadors ? this.updatedAmbassadors() || [] : [];
    },
    // Computed свойство для отслеживания активного таба из URL
    currentTabFromRoute() {
      const routeName = this.$route.name;
      if (routeName === 'TasksAvailable') return 0;
      if (routeName === 'TasksInProgress') return 1;
      if (routeName === 'TasksCompleted') return 2;
      return 0; // default
    },
  },
  watch: {
    isAuthenticated(val) {
      if (val) {
        this.onHashChange().catch((error) => {
          console.error('Error in onHashChange:', error);
        });
      }
    },
    routeName() {
      this.defineCurrentTab();
      // Данные загрузятся через watcher currentTabFromRoute
    },
    themeDone(val) {
      if (val) {
        this.setupFiltersAndSorting();
      }
    },
    isFiltersLoaded() {
      // Убираем вызов loadTasks отсюда, так как он уже вызывается в mounted()
    },
    'taskDetailsOptions.participantExerciseChain.endDate': {
      handler(val) {
        if (val) {
          this.setCountdown(val);
        }
      },
      immediate: true,
    },
    // Синхронизация selectedTab с URL
    currentTabFromRoute: {
      handler(newTab) {
        if (this.selectedTab !== newTab) {
          this.selectedTab = newTab;
          // Обновляем данные для активного таба при переключении
          if (this.initialLoadCompleted) {
            this.updateCurrentTabData();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('user', ['getProfile']),
    ...mapActions('trackers', ['getTrackers']),
    ...mapActions('wallet', ['getBalance']),
    ...mapActions('exercises', ['getTaskPoints', 'getTasksAvailable', 'getTasksInProgress', 'getTasksCompleted', 'getTask', 'getTaskGuest', 'assignTask', 'assignTaskChain', 'getDisciplines', 'getChain', 'getChainParicipants']),
    ...mapActions('partners', ['getActivityRegistration', 'createParticipatingActivities']),
    ...mapActions('content', ['getAmbassadors']),

    updatedAmbassadors() {
      return this.ambassadors.map((ambassador) => ({
        name: ambassador.fullName,
        avatar: ambassador.desktopImageUrl,
        avatarMobile: ambassador.mobileImageUrl,
        taskText: ambassador.content,
        quote: ambassador.description,
      }));
    },

    bannerAboutTasksClose() {
      this.bannerAboutTasks = false;
      sessionStorage.setItem('bannerAboutTasks', false);
    },
    defineCurrentTab() {
      // Используем computed свойство для определения таба
      this.selectedTab = this.currentTabFromRoute;
    },
    changeTab(index) {
      const prevTab = this.selectedTab;
      let url = '';
      if (index === 0) url = '/tasks/available';
      if (index === 1) url = '/tasks/in-progress';
      if (index === 2) url = '/tasks/completed';

      // Обновляем URL только если он действительно изменился
      if (url && this.$route.path !== url) {
        this.$router.replace(url);
      }

      this.selectedTab = index;

      // Очищаем фильтры при переходе с вкладки "Доступны"
      if (prevTab === 0 && this.selectedTab !== prevTab && this.hasActiveFilters) {
        this.removeFilters();
        window.scrollTo(0, 0);
      }

      // Обновляем данные для активного таба при переключении
      if (this.initialLoadCompleted) {
        this.updateCurrentTabData();
      }
    },
    onStartChain() {
      this.chainTaskDetailsModal = false;

      if (this.taskDetailsOptions && this.taskDetailsOptions.links) {
        const hasChainOnlyTasks = this.taskDetailsOptions.links.some((link) => link.isChainOnly === true);
        if (hasChainOnlyTasks) {
          // Можно добавить уведомление пользователю
        }
      }

      this.getTrackers()
        .then(() => {
          if (this.trackers.filter((i) => i.state === 'Connected').length > 0) {
            // Есть подключенный трекер - назначаем задание
            localStorage.removeItem('returnFromGuide');
            const participantExerciseChainId = uuidv4();
            this.assignTaskChain({ participantExerciseChainId, exerciseChainId: this.exerciseChainId })
              .then(() => {
                if (this.responseStatus === 204) {
                  this.changeTab(1);
                  this.removeFilters();
                  window.scrollTo(0, 0);
                  window.location.hash = `#!showTask=${this.exerciseChainId}&peId=${participantExerciseChainId}`;
                  this.loadTasks();
                }
              })
              .catch((error) => {
                // Обрабатываем ошибку если участник не подключил трекеры
                if (error.response && error.response.status === 422) {
                  console.error('Ошибка назначения цепочки:', error.response.data);
                  // Показываем онбординг для подключения трекера
                  if (this.$root.showOnboarding) {
                    localStorage.setItem('returnToChain', this.exerciseChainId);
                    this.$root.showOnboarding({ step: 'choose' });
                  }
                }
              });
            return;
          }
          // Нет подключенного трекера - показываем онбординг
          if (this.$root.showOnboarding) {
            localStorage.setItem('returnToChain', this.exerciseChainId);
            this.$root.showOnboarding({ step: 'choose' });
          }
        });
    },
    onStart() {
      if (this.taskDetailsOptions && this.taskDetailsOptions.isChainOnly === true) {
        return;
      }

      if (this.taskDetailsOptions) {
        if (this.taskDetailsOptions.isTrackerNeeded !== true) {
          const participantExerciseId = uuidv4();
          this.assignTask({ participantExerciseId, exerciseId: this.taskDetailsExerciseId })
            .then(() => {
              if (this.responseStatus === 204) {
                this.changeTab(1);
                this.removeFilters();
                window.scrollTo(0, 0);
                window.location.hash = `#!showTask=${this.taskDetailsExerciseId}&peId=${participantExerciseId}`;
                this.loadTasks();
              }
            });
          return;
        }
      }
      this.getTrackers()
        .then(() => {
          if (this.trackers.filter((i) => i.state === 'Connected').length > 0) {
            localStorage.removeItem('returnFromGuide');
            const participantExerciseId = uuidv4();
            this.assignTask({ participantExerciseId, exerciseId: this.taskDetailsExerciseId })
              .then(() => {
                if (this.responseStatus === 204) {
                  this.changeTab(1);
                  this.removeFilters();
                  window.scrollTo(0, 0);
                  window.location.hash = `#!showTask=${this.taskDetailsExerciseId}&peId=${participantExerciseId}`;
                  this.loadTasks();
                }
              })
              .catch((error) => {
                // Обрабатываем ошибку если участник не подключил трекеры
                if (error.response && error.response.status === 422) {
                  console.error('Ошибка назначения задания:', error.response.data);
                  // Показываем онбординг для подключения трекера
                  if (this.$root.showOnboarding) {
                    localStorage.setItem('returnToTask', this.taskDetailsExerciseId);
                    this.$root.showOnboarding({ step: 'choose' });
                  }
                }
              });
            return;
          }
          if (this.$root.showOnboarding) {
            localStorage.setItem('returnToTask', this.taskDetailsExerciseId);
            this.$root.showOnboarding({ step: 'choose' });
          }
        });
    },
    async onShowTask(index) {
      let tasks = null;
      if (this.selectedTab === 0) {
        tasks = this.availableItems;
        this.hideFiltersDropdown = true;
        setTimeout(() => { this.hideFiltersDropdown = false; }, 250);
      }
      if (this.selectedTab === 1) tasks = this.inProgressItems;
      if (this.selectedTab === 2) tasks = this.completedItems;

      if (tasks) {
        const task = tasks[index];

        if (task.exerciseChainId) {
          this.exerciseChainId = task.exerciseChainId;

          const currentHash = window.location.hash;
          const expectedHash = this.selectedTab === 0
            ? `#!showTask=${task.exerciseChainId}`
            : `#!showTask=${task.exerciseChainId}&peId=${task.exerciseChainInfo?.participantExerciseChain?.participantExerciseChainId || ''}`;

          if (currentHash !== expectedHash) {
            if (this.selectedTab === 0) {
              window.location.hash = `#!showTask=${task.exerciseChainId}`;
            } else {
              const participantExerciseChainId = task.exerciseChainInfo?.participantExerciseChain?.participantExerciseChainId;
              if (participantExerciseChainId) {
                window.location.hash = `#!showTask=${task.exerciseChainId}&peId=${participantExerciseChainId}`;
              } else {
                window.location.hash = `#!showTask=${task.exerciseChainId}`;
              }
            }
          }

          this.chainTaskDetailsModal = true;
          this.taskDetailsModal = false;
        } else {
          const participantExerciseTaskId = task.participantExercise && task.participantExercise.tasks && task.participantExercise.tasks[0] ? task.participantExercise.tasks[0].participantExerciseTaskId : null;
          const participantExerciseTaskId1 = task.participantExercise && task.participantExercise.tasks && task.participantExercise.tasks[1] ? task.participantExercise.tasks[1].participantExerciseTaskId : null;
          localStorage.removeItem('returnToTask');
          window.location.hash = `#!showTask=${task.exerciseId}${this.selectedTab !== 0 ? `&peId=${task.participantExercise.participantExerciseId}` : ''}`;
          if (task.participantExercise && task.participantExercise.tasks && task.participantExercise.tasks[0] && task.participantExercise.tasks[0].state === 'Completed') {
            this.getActivityRegistration({ participantExerciseTaskId })
              .then(() => {
                const id = uuidv4();
                this.createParticipatingActivities(
                  {
                    activityId: id,
                    exerciseTaskId: participantExerciseTaskId1,
                    sessionId: this.registration.sessionId,
                  },
                );
              })
              .catch((error) => {
                console.error('Ошибка', error);
              });
          }
          this.taskDetailsOptions = task;
          this.taskDetailsState = this.getTaskDetailsState(task);
          this.taskDetailsExerciseId = task.exerciseId;
          this.taskDetailsModal = true;
          this.chainTaskDetailsModal = false;
        }
      }
    },
    onTaskDetailsClose(eventData = {}) {
      if (this.taskDetailsModal === false) {
        return;
      }

      this.taskDetailsModal = false;
      window.scroll(0, this.pageScrollY);

      const wasOpenedFromChain = eventData.openedFromChain || this.openedFromChain;

      if (wasOpenedFromChain && this.savedChainData) {
        this.taskDetailsOptions = this.savedChainData.taskDetailsOptions;
        this.taskRating = this.savedChainData.taskRating;
        this.taskDetailsState = this.savedChainData.taskDetailsState;
        this.chainTaskDetailsModal = true;

        if (this.savedChainData.chainHash) {
          window.location.hash = this.savedChainData.chainHash;
        } else if (this.taskDetailsOptions.exerciseChainId) {
          const participantExerciseChainId = this.taskDetailsOptions.exerciseChainInfo?.participantExerciseChain?.participantExerciseChainId;
          if (participantExerciseChainId) {
            const chainHash = `#!showTask=${this.taskDetailsOptions.exerciseChainId}&peId=${participantExerciseChainId}`;
            window.location.hash = chainHash;
          } else {
            const chainHash = `#!showTask=${this.taskDetailsOptions.exerciseChainId}`;
            window.location.hash = chainHash;
          }
        }

        this.openedFromChain = false;
        this.savedChainData = null;
        return;
      }

      this.openedFromChain = false;
      this.savedChainData = null;
      this.lastProcessedHash = '';
      this.hashProcessedAfterLoad = false;
      window.location.hash = '';
    },
    onChainTaskDetailsClose() {
      this.chainTaskDetailsModal = false;
      this.openedFromChain = false;
      window.scroll(0, this.pageScrollY);
      this.lastProcessedHash = '';
      this.hashProcessedAfterLoad = false;
      window.location.hash = '';
    },
    onShowChainTask({ exerciseId, participantExerciseId }) {
      this.openedFromChain = true;

      this.savedChainData = {
        taskDetailsOptions: { ...this.taskDetailsOptions },
        taskRating: { ...this.taskRating },
        taskDetailsState: this.taskDetailsState,
        chainHash: window.location.hash,
      };

      this.chainTaskDetailsModal = false;

      this.taskDetailsOptions = {};
      this.taskRating = {};
      this.taskDetailsModal = false;

      if (participantExerciseId) {
        this.loadMyTask(exerciseId, participantExerciseId);
      } else {
        this.loadTask(exerciseId);
      }
    },
    onOpenActiveChain({ participantExerciseChainId }) {
      this.loadMyChain(participantExerciseChainId, participantExerciseChainId);
    },

    onChainCancelled() {
      // Обновляем данные после отмены цепочки
      this.loadTasks();
    },

    async onHashChange() {
      if (this.$route.name !== 'Tasks'
          && this.$route.name !== 'TasksAvailable'
          && this.$route.name !== 'TasksInProgress'
          && this.$route.name !== 'TasksCompleted') {
        window.removeEventListener('hashchange', this.onHashChange);
        return;
      }

      if (!this.isFiltersLoaded || this.loading) {
        return;
      }

      if (!window.location.hash || window.location.hash === '') {
        return;
      }

      const hash = window.location.hash.split('=');
      if (hash[0] !== '#!showTask') return;

      if (this.lastProcessedHash === window.location.hash) {
        return;
      }

      if (this.lastProcessedHash && this.lastProcessedHash.includes('#!showTask') && window.location.hash === '') {
        this.lastProcessedHash = '';
        return;
      }

      if (this.hashProcessedAfterLoad && this.lastProcessedHash === window.location.hash) {
        return;
      }

      if (this.lastProcessedHash && this.lastProcessedHash.includes('&peId=')
          && window.location.hash === this.lastProcessedHash.split('&peId=')[0]) {
        return;
      }

      this.lastProcessedHash = window.location.hash;

      if (hash.length === 2) {
        const exerciseId = hash[1];

        if (!exerciseId || exerciseId === 'undefined' || exerciseId === 'null') {
          window.location.hash = '';
          return;
        }

        let chain = this.availableItems.find((t) => t.exerciseChainId === exerciseId);
        let exercise = this.availableItems.find((t) => t.exerciseId === exerciseId);

        if (!chain) {
          chain = this.inProgressItems.find((t) => t.exerciseChainId === exerciseId);
        }
        if (!exercise) {
          exercise = this.inProgressItems.find((t) => t.exerciseId === exerciseId);
        }

        if (!chain) {
          chain = this.completedItems.find((t) => t.exerciseChainId === exerciseId);
        }
        if (!exercise) {
          exercise = this.completedItems.find((t) => t.exerciseId === exerciseId);
        }

        if (chain) {
          await this.loadMyChain(exerciseId);
        } else if (exercise) {
          await this.loadTask(exerciseId);
        } else {
          const isLikelyChain = exerciseId.length === 36 && exerciseId.includes('-');

          if (this.availableItems.length === 0 && this.inProgressItems.length === 0 && this.completedItems.length === 0) {
            if (isLikelyChain) {
              try {
                await this.loadMyChain(exerciseId);
              } catch (error) {
                await this.loadTask(exerciseId);
              }
            } else {
              try {
                await this.loadTask(exerciseId);
              } catch (error) {
                await this.loadMyChain(exerciseId);
              }
            }
          } else {
            try {
              await this.loadMyChain(exerciseId);
            } catch (chainError) {
              await this.loadTask(exerciseId);
            }
          }
        }
      }

      if (hash.length === 3 && hash[1].indexOf('&peId') >= 0) {
        const exerciseId = hash[1].split('&peId')[0];
        const peId = hash[2];

        if (!exerciseId || exerciseId === 'undefined' || exerciseId === 'null'
          || !peId || peId === 'undefined' || peId === 'null') {
          console.error('Invalid exerciseId or peId:', { exerciseId, peId });
          window.location.hash = '';
          return;
        }

        let chain = this.availableItems.find((t) => t.exerciseChainId === exerciseId);
        let exercise = this.availableItems.find((t) => t.exerciseId === exerciseId);

        if (!chain) {
          chain = this.inProgressItems.find((t) => t.exerciseChainId === exerciseId);
        }
        if (!exercise) {
          exercise = this.inProgressItems.find((t) => t.exerciseId === exerciseId);
        }

        if (!chain) {
          chain = this.completedItems.find((t) => t.exerciseChainId === exerciseId);
        }
        if (!exercise) {
          exercise = this.completedItems.find((t) => t.exerciseId === exerciseId);
        }

        if (chain) {
          await this.loadMyChain(exerciseId, peId);
        } else if (exercise) {
          await this.loadMyTask(exerciseId, peId);
        } else {
          const isLikelyChain = exerciseId.length === 36 && exerciseId.includes('-');

          if (this.availableItems.length === 0 && this.inProgressItems.length === 0 && this.completedItems.length === 0) {
            if (isLikelyChain) {
              try {
                await this.loadMyChain(exerciseId, peId);
              } catch (error) {
                await this.loadMyTask(exerciseId, peId);
              }
            } else {
              try {
                await this.loadMyTask(exerciseId, peId);
              } catch (error) {
                await this.loadMyChain(exerciseId, peId);
              }
            }
          } else {
            try {
              await this.loadMyChain(exerciseId, peId);
            } catch (chainError) {
              await this.loadMyTask(exerciseId, peId);
            }
          }
        }
      }
    },

    async loadMyChain(exerciseChainId, participantExerciseChainId) {
      this.taskDetailsOptions = {};
      this.taskRating = {};
      this.chainTaskDetailsModal = false;
      this.taskDetailsModal = false;

      if (participantExerciseChainId) {
        try {
          const participantChainData = await this.getChainParicipants(participantExerciseChainId);
          if (participantChainData) {
            this.pageScrollY = window.scrollY;
            this.taskDetailsState = this.getTaskDetailsState(participantChainData);
            this.taskDetailsOptions = participantChainData;
            await this.getTaskPoints(exerciseChainId);
            this.taskRating = this.taskPoints;
            this.chainTaskDetailsModal = true;

            const state = participantChainData.participantExerciseChain?.state;
            if (state === 'Created' && this.selectedTab !== 1) {
              this.changeTab(1, false);
            } else if (state === 'Completed' && this.selectedTab !== 2) {
              this.changeTab(2, false);
            }

            return true;
          }
        } catch (error) {
          // Игнорируем ошибки загрузки
        }
      }

      try {
        const chainData = await this.getChain(exerciseChainId);
        if (chainData) {
          this.pageScrollY = window.scrollY;
          this.taskDetailsState = 'Published';
          this.taskDetailsOptions = chainData;
          await this.getTaskPoints(exerciseChainId);
          this.taskRating = this.taskPoints;
          this.chainTaskDetailsModal = true;

          if (participantExerciseChainId) {
            // Если есть peId, оставляем на текущей вкладке
          } else if (this.selectedTab !== 0) {
            this.changeTab(0, false);
          }

          return true;
        }
      } catch (error) {
        // Игнорируем ошибки загрузки
      }

      this.lastProcessedHash = '';
      window.location.hash = '';
      throw new Error('Chain not found');
    },
    onFilterChange(filters) {
      const result = {};
      const keys = Object.keys(filters);
      for (let i = 0; i < keys.length; i += 1) {
        if (filters[keys[i]].val !== null) result[keys[i]] = filters[keys[i]];
      }
      this.activeFilters = result;
      const vm = this;
      this.offsetAvailable = 0;
      this.getTasksAvailable({ offset: 0, count: 12, ...this.getFilters() })
        .then(() => {
          if (this.responseStatus === 200) {
            window.scrollTo(0, 0);
            this.availableItems = this.tasksAvailable ? this.tasksAvailable.values : [];
            if (this.availableItems.length === 0 && this.selectedTab === 0 && !this.hasActiveFilters) {
              this.changeTab(1);
              return;
            }
            if (this.selectedTab === 0) {
              setTimeout(() => { vm.setupLoader(); }, 250);
            }
          }
        });
    },
    onFilterReset() {
      this.activeFilters = {};
      const vm = this;
      this.offsetAvailable = 0;
      this.getTasksAvailable({ offset: 0, count: 12, ...this.getFilters() })
        .then(() => {
          if (this.responseStatus === 200) {
            window.scrollTo(0, 0);
            this.availableItems = this.tasksAvailable ? this.tasksAvailable.values : [];
            if (this.availableItems.length === 0 && this.selectedTab === 0) {
              this.changeTab(1);
              return;
            }
            if (this.selectedTab === 0) {
              setTimeout(() => { vm.setupLoader(); }, 250);
            }
          }
        });
    },
    setupFiltersAndSorting() {
      if (this.enabledMarketFilters) {
        const keys = Object.keys(this.filters);
        for (let i = 0; i < keys.length; i += 1) {
          if (!this.enabledMarketFilters.includes(keys[i])) {
            delete this.filters[keys[i]];
          }
        }
      }
    },
    setDisciplineFilter() {
      if (this.disciplines && this.filters.discipline) {
        let filters = [];
        for (let i = 0; i < this.disciplines.length; i += 1) {
          const discipline = this.disciplineNames.find((item) => item.id === this.disciplines[i]);
          const name = discipline ? discipline.name : this.disciplines[i];
          const order = discipline ? discipline.order : this.disciplineNames.length + i + 1;
          const group = discipline ? discipline.group : null;
          const item = { id: this.disciplines[i], name, order };
          if (group) item.group = group;
          filters.push(item);
        }
        filters = filters.sort(this.sortItemsByOrder);
        this.availableFilters.discipline = [...filters];

        filters = this.getCollapsedByGroup(filters);
        this.filters.discipline = filters;
      }
    },
    getFilters() {
      const result = {};
      if (this.activeFilters.discipline) {
        result.discipline = this.activeFilters.discipline.val || [];
      }
      return this.expandGroups(result);
    },
    removeFilters() {
      this.$router.replace({ }).catch(() => { });
      this.activeFilters = {};
    },
    sortItemsByOrder(a, b) {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    },
    getCollapsedByGroup(filters) {
      const collapsed = [];
      for (let i = 0; i < filters.length; i += 1) {
        if (!filters[i].group) {
          collapsed.push(filters[i]);
          continue;
        }
        if (collapsed.filter((item) => item.group === filters[i].group).length === 0) {
          const item = { ...filters[i] };
          item.id = filters[i].group;
          collapsed.push(item);
        }
      }
      return collapsed;
    },
    expandGroups(filters) {
      const result = { ...filters };
      const keys = Object.keys(result);
      for (let i = 0; i < keys.length; i += 1) {
        const val = [...result[keys[i]]];
        const values = [];
        for (let k = 0; k < val.length; k += 1) {
          const items = this.availableFilters.discipline.filter((item) => item.group && item.group === val[k]);
          if (items.length > 0) {
            values.push(...(items.map((item) => item.id)));
            continue;
          }
          values.push(val[k]);
        }
        result[keys[i]] = values;
      }
      return result;
    },
    async loadTask(id) {
      this.taskDetailsOptions = {};
      this.taskRating = {};
      this.chainTaskDetailsModal = false;

      try {
        await this.getTaskGuest(id);
        if (this.taskGuest) {
          this.pageScrollY = window.scrollY;
          this.taskDetailsState = 'available';
          this.taskDetailsExerciseId = id;
          this.taskDetailsOptions = this.taskGuest;
          await this.getTaskPoints(id);
          this.taskRating = this.taskPoints;
          this.taskDetailsModal = true;
          return true;
        }
      } catch (error) {
        this.lastProcessedHash = '';
        window.location.hash = '';
      }

      return false;
    },
    async loadMyTask(id, peId) {
      if (this.openedFromChain && this.savedChainData) {
        if (this.savedChainData.taskDetailsOptions && this.savedChainData.taskDetailsOptions.participantExerciseChain) {
          const { links } = this.savedChainData.taskDetailsOptions.participantExerciseChain;

          if (links && Array.isArray(links)) {
            const targetLink = links.find((link) => {
              if (link.participantExerciseId === peId) {
                return true;
              }

              if (link.participantExercise && link.participantExercise.participantExerciseId === peId) {
                return true;
              }

              if (link.participantExerciseChainLinkId === peId) {
                return true;
              }

              return false;
            });

            if (targetLink) {
              let participantExerciseId = null;

              if (targetLink.participantExerciseId) {
                participantExerciseId = targetLink.participantExerciseId;
              } else if (targetLink.participantExercise && targetLink.participantExercise.participantExerciseId) {
                participantExerciseId = targetLink.participantExercise.participantExerciseId;
              } else if (targetLink.participantExerciseChainLinkId) {
                participantExerciseId = targetLink.participantExerciseChainLinkId;
              }

              if (participantExerciseId) {
                try {
                  await this.getTask(participantExerciseId);
                  if (this.task) {
                    this.pageScrollY = window.scrollY;
                    this.taskDetailsState = this.getTaskDetailsState(this.task);
                    this.taskDetailsExerciseId = participantExerciseId;
                    this.taskDetailsOptions = this.task;

                    if (targetLink.isChainOnly === true) {
                      this.taskDetailsOptions.isChainOnly = true;
                    }

                    let exerciseId = null;
                    if (targetLink.exercise && targetLink.exercise.exerciseId) {
                      exerciseId = targetLink.exercise.exerciseId;
                    } else if (targetLink.exerciseChainLink && targetLink.exerciseChainLink.exercise && targetLink.exerciseChainLink.exercise.exerciseId) {
                      exerciseId = targetLink.exerciseChainLink.exercise.exerciseId;
                    }

                    if (exerciseId) {
                      await this.getTaskPoints(exerciseId);
                      this.taskRating = this.taskPoints;
                    }

                    this.taskDetailsModal = true;
                    return true;
                  }
                  this.openedFromChain = false;
                  this.savedChainData = null;
                  this.chainTaskDetailsModal = true;
                  return false;
                } catch (error) {
                  this.openedFromChain = false;
                  this.savedChainData = null;
                  this.chainTaskDetailsModal = true;
                  throw error;
                }
              }
            }
          }
        }

        this.openedFromChain = false;
        this.savedChainData = null;
        this.chainTaskDetailsModal = true;
        return false;
      }

      try {
        await this.getTask(peId);
        if (this.task) {
          this.pageScrollY = window.scrollY;
          this.taskDetailsState = this.getTaskDetailsState(this.task);
          this.taskDetailsExerciseId = peId;
          this.taskDetailsOptions = this.task;
          await this.getTaskPoints(id);
          this.taskRating = this.taskPoints;
          this.taskDetailsModal = true;
          return true;
        }
        if (!this.openedFromChain) {
          this.changeTab(0);
          window.location.hash = `#!showTask=${id}`;
        }
        return false;
      } catch (error) {
        if (!this.openedFromChain) {
          this.changeTab(0);
          window.location.hash = `#!showTask=${id}`;
        }
        throw error;
      }
    },
    getTabText(tab) {
      if (tab === 0) return { title: `<div>${this.tasksAvailable ? this.tasksAvailable.total : 0}</div><div>Доступны</div>`, enabled: true };
      if (tab === 1) return { title: `<div>${this.tasksInProgress ? this.tasksInProgress.total : 0}</div><div>Выполняются</div>`, enabled: this.tasksInProgress ? this.tasksInProgress.total > 0 : false };
      return { title: `<div>${this.tasksCompleted ? this.tasksCompleted.total : 0}</div><div>Завершены</div>`, enabled: this.tasksCompleted ? this.tasksCompleted.total > 0 : false };
    },
    getTaskReward(task) {
      // Если есть ненулевой reward на уровне задания, используем его
      const taskReward = task && task.reward !== undefined && task.reward !== null ? Number(task.reward) : NaN;
      if (Number.isFinite(taskReward) && taskReward > 0) {
        return Math.round(taskReward);
      }

      // Иначе используем reward из работ (tasks), как до новой схемы
      let reward = 0;
      if (!task || !task.tasks) return reward;
      for (let i = 0; i < task.tasks.length; i += 1) {
        reward += task.tasks[i].reward;
      }
      return Math.round(reward);
    },

    getTaskRewardRange(task) {
      // Если есть ненулевой reward на уровне задания, используем его (без диапазона)
      const taskReward = task && task.reward !== undefined && task.reward !== null ? Number(task.reward) : NaN;
      if (Number.isFinite(taskReward) && taskReward > 0) {
        return Math.round(taskReward);
      }

      let reward = 0;
      let maxReward = 0;

      if (!task) return reward;
      if (task.tasks && Array.isArray(task.tasks)) {
        for (let i = 0; i < task.tasks.length; i += 1) {
          reward += task.tasks[i].reward || 0;
          maxReward += task.tasks[i].maxReward || 0;
        }
      }
      if (task.exerciseChainInfo) {
        reward += task.exerciseChainInfo.reward || 0;
        maxReward += task.exerciseChainInfo.maxReward || 0;
      }
      return maxReward && reward < maxReward ? `${Math.round(reward)}-${maxReward}` : Math.round(reward);
    },
    getIsFlexibleCost(task) {
      const reward = this.getTaskReward(task);
      if (!task || !task.tasks) return false;
      let maxReward = 0;
      for (let i = 0; i < task.tasks.length; i += 1) {
        maxReward += task.tasks[i].maxReward;
      }
      return reward < maxReward;
    },
    getCompletedTaskState(task) {
      if (!task) return '';

      if (task.exerciseChainId && task.exerciseChainInfo && task.exerciseChainInfo.participantExerciseChain) {
        const participantChain = task.exerciseChainInfo.participantExerciseChain;
        if (participantChain.state === 'Completed') return 'completed';
        if (participantChain.state === 'Rejected') return 'failed';
        if (participantChain.state === 'AwaitingConfirmation') return 'checking';
        return '';
      }

      if (task.participantExercise && task.participantExercise.state === 'Completed') return 'completed';
      if (task.participantExercise && task.participantExercise.state === 'Rejected') return 'failed';
      if (task.participantExercise && task.participantExercise.state === 'AwaitingConfirmation') return 'checking';
      return '';
    },
    getState() {
      if (this.selectedTab === 0) return 'available';
      if (this.selectedTab === 1) return 'inProgress';
      return 'completed';
    },
    getTaskDetailsState(task) {
      if (!task) return 'available';

      if (task.exerciseChainId) {
        if (this.selectedTab === 0) {
          return 'available';
        }
        const participantChain = task.exerciseChainInfo && task.exerciseChainInfo.participantExerciseChain;
        if (!participantChain) return 'available';
        if (participantChain.state === 'Created') return 'inProgress';
        if (participantChain.state === 'Completed') return 'completed';
        if (participantChain.state === 'Rejected') return 'failed';
        if (participantChain.state === 'AwaitingConfirmation') return 'checking';
        return 'available';
      }

      if (!task.participantExercise) return 'available';
      if (task.participantExercise.state === 'Created') return 'inProgress';
      if (task.participantExercise.state === 'Completed') return 'completed';
      if (task.participantExercise.state === 'Rejected') return 'failed';
      if (task.participantExercise.state === 'AwaitingConfirmation') return 'checking';
      return 'available';
    },
    getChainStatusClass(task) {
      if (!task.exerciseChainInfo || !task.exerciseChainInfo.countLinksTotal || task.exerciseChainInfo.countLinksTotal === 0) {
        return '';
      }

      const state = this.getTaskDetailsState(task);
      return `task--chain--${state}`;
    },
    setupLoader() {
      const vm = this;
      if (vm.loaderBlock !== null) return;
      if (vm.$route.name !== 'Tasks'
          && vm.$route.name !== 'TasksAvailable'
          && vm.$route.name !== 'TasksInProgress'
          && vm.$route.name !== 'TasksCompleted') {
        return;
      }
      const loaders = document.getElementsByClassName('tasks__loader-block');
      vm.loaderBlock = loaders[0] || null;
      window.addEventListener('scroll', vm.checkForLoading);
      window.addEventListener('touchmove', vm.checkForLoading);
      vm.checkForLoading();
    },
    checkForLoading() {
      if (this.updating) return;
      if (!this.loaderBlock) return;
      if (this.$route.name !== 'Tasks'
          && this.$route.name !== 'TasksAvailable'
          && this.$route.name !== 'TasksInProgress'
          && this.$route.name !== 'TasksCompleted') {
        this.cleanup();
        return;
      }

      if (this.getTasks() === null) return;
      if (!this.hasTasksForLoading()) return;

      const bottomCoord = this.loaderBlock.getBoundingClientRect().bottom;
      const height = document.documentElement.clientHeight;
      if (height >= bottomCoord) {
        this.updating = true;
        setTimeout(() => { this.updateTasks(); }, 250);
      }
    },
    cleanup() {
      window.removeEventListener('scroll', this.checkForLoading);
      window.removeEventListener('touchmove', this.checkForLoading);
    },
    loadTasks() {
      // Защита от повторных вызовов при первоначальной загрузке
      if (this.initialLoadCompleted) {
        return;
      }

      const vm = this;
      let loadedCount = 0;
      const totalToLoad = 3;

      const checkAllLoaded = () => {
        loadedCount += 1;
        if (loadedCount === totalToLoad) {
          this.initialLoadCompleted = true;
          if (window.location.hash.includes('#!showTask') && !this.hashProcessedAfterLoad) {
            this.hashProcessedAfterLoad = true;
            this.onHashChange().catch((error) => {
              console.error('Error in onHashChange after tasks loaded:', error);
            });
          }
        }
      };

      // Загружаем данные для всех табов при первоначальной загрузке
      this.getTasksAvailable({ offset: 0, count: 12, ...this.getFilters() })
        .then(() => {
          if (this.responseStatus === 200) {
            this.availableItems = this.tasksAvailable ? this.tasksAvailable.values : [];
            if (this.selectedTab === 0) {
              setTimeout(() => { vm.setupLoader(); }, 250);
            }
          }
          checkAllLoaded();
        })
        .catch(() => checkAllLoaded());

      this.getTasksInProgress({ offset: 0, count: 12 })
        .then(() => {
          if (this.responseStatus === 200) {
            this.inProgressItems = this.tasksInProgress ? this.tasksInProgress.values : [];
            if (this.selectedTab === 1) {
              setTimeout(() => { vm.setupLoader(); }, 250);
            }
          }
          checkAllLoaded();
        })
        .catch(() => checkAllLoaded());

      this.getTasksCompleted({ offset: 0, count: 12 })
        .then(() => {
          if (this.responseStatus === 200) {
            this.completedItems = this.tasksCompleted ? this.tasksCompleted.values : [];
            if (this.selectedTab === 2) {
              setTimeout(() => { vm.setupLoader(); }, 250);
            }
          }
          checkAllLoaded();
        })
        .catch(() => checkAllLoaded());
    },

    // Обновление данных для текущего таба
    updateCurrentTabData() {
      switch (this.selectedTab) {
        case 0:
          this.getTasksAvailable({ offset: 0, count: 12, ...this.getFilters() })
            .then(() => {
              if (this.responseStatus === 200) {
                this.availableItems = this.tasksAvailable ? this.tasksAvailable.values : [];
              }
            });
          break;
        case 1:
          this.getTasksInProgress({ offset: 0, count: 12 })
            .then(() => {
              if (this.responseStatus === 200) {
                this.inProgressItems = this.tasksInProgress ? this.tasksInProgress.values : [];
              }
            });
          break;
        case 2:
          this.getTasksCompleted({ offset: 0, count: 12 })
            .then(() => {
              if (this.responseStatus === 200) {
                this.completedItems = this.tasksCompleted ? this.tasksCompleted.values : [];
              }
            });
          break;
        default:
          console.warn('Unknown tab index:', this.selectedTab);
          break;
      }
    },

    updateTasks() {
      if (this.selectedTab === 0) {
        this.offsetAvailable += 12;
        this.getTasksAvailable({ offset: this.offsetAvailable, count: 12, ...this.getFilters() })
          .then(() => {
            if (this.responseStatus === 200) {
              this.availableItems.push(...this.tasksAvailable.values);
            }
            this.updating = false;
          });
        return;
      }
      if (this.selectedTab === 1) {
        this.offsetInProgress += 12;
        this.getTasksInProgress({ offset: this.offsetInProgress, count: 12 })
          .then(() => {
            if (this.responseStatus === 200) {
              this.inProgressItems.push(...this.tasksInProgress.values);
            }
            this.updating = false;
          });
        return;
      }
      if (this.selectedTab === 2) {
        this.offsetCompleted += 12;
        this.getTasksCompleted({ offset: this.offsetCompleted, count: 12 })
          .then(() => {
            if (this.responseStatus === 200) {
              this.completedItems.push(...this.tasksCompleted.values);
            }
            this.updating = false;
          });
      }
    },
    getTasks() {
      if (this.selectedTab === 0) return this.tasksAvailable;
      if (this.selectedTab === 1) return this.tasksInProgress;
      return this.tasksCompleted;
    },
    hasTasksForLoading() {
      let tasks = { count: 0 };
      let items = [];
      if (this.selectedTab === 0) {
        tasks = this.tasksAvailable;
        items = this.availableItems;
      }
      if (this.selectedTab === 1) {
        tasks = this.tasksInProgress;
        items = this.inProgressItems;
      }
      if (this.selectedTab === 2) {
        tasks = this.tasksCompleted;
        items = this.completedItems;
      }
      if (tasks.count === 0) return false;
      if (items.length >= tasks.total) return false;
      return true;
    },
    isRepeat(task) {
      return task.type === 'Reusable';
    },
    disciplineIcon(task) {
      const disciplineIconMap = {
        Invite: 'invite',
        Running: 'running',
        Cycling: 'cycling',
        Skiing: 'skiing',
        Swimming: 'swimming',
        Walking: 'walking',
        Quiz: 'quiz',
        Survey: 'quiz',
        GeoLocation: 'geolocation',
        PartnerLink: 'partnerlink',
        Registration: 'registration',
        Participation: 'participation',
        UploadImage: 'uploadimage',
        Fitness: 'heart',
        Strength: 'heart',
        MartialArts: 'heart',
        Playing: 'heart',
        Extreme: 'heart',
        Outdoor: 'heart',
        Dancing: 'heart',
      };

      const heartDisciplines = [
        'Fitness', 'Strength', 'MartialArts', 'Playing', 'Extreme', 'Outdoor', 'Dancing',
      ];

      if (!task) return [];

      const icons = [];
      let hasHeart = false;

      // Проверяем наличие дисциплин в exerciseChainInfo
      if (task.exerciseChainInfo?.disciplines) {
        task.exerciseChainInfo.disciplines.forEach((discipline) => {
          if (heartDisciplines.includes(discipline)) {
            hasHeart = true;
          } else {
            const icon = disciplineIconMap[discipline] || '';
            if (icon && !icons.includes(icon)) {
              icons.push(icon);
            }
          }
        });
        if (hasHeart) icons.unshift('heart');
        return icons;
      }

      // Если task.tasks существует, обрабатываем его
      if (task.tasks) {
        const uniqueIcons = new Set();
        for (let i = 0; i < task.tasks.length; i += 1) {
          const discipline = task.tasks[i].settings.Discipline;
          if (heartDisciplines.includes(discipline)) {
            hasHeart = true;
          } else {
            const icon = disciplineIconMap[discipline] || '';
            if (icon && !uniqueIcons.has(icon)) {
              uniqueIcons.add(icon);
              icons.push(icon);
            }
          }
        }
        if (hasHeart) icons.unshift('heart');
        return icons;
      }

      return [];
    },
    getItemsTotal(task) {
      if (task.exerciseChainId) {
        if (this.selectedTab === 0) {
          return task.links ? task.links.length : 0;
        }
        return task.exerciseChainInfo.participantExerciseChain.countLinksTotal || 0;
      }

      if (task.participantExercise && task.participantExercise.tasks) {
        return task.participantExercise.tasks.length;
      }
      return 0;
    },
    getItemsDone(task) {
      if (task.exerciseChainId) {
        if (this.selectedTab === 0) {
          return 0;
        }
        return task.exerciseChainInfo.participantExerciseChain.countLinksCompleted || 0;
      }

      if (task.participantExercise && task.participantExercise.tasks) {
        return task.participantExercise.tasks.filter((i) => i.state === 'Completed').length;
      }
      return 0;
    },
    getCompletedTaskCost(task) {
      if (task.exerciseChainId) {
        const participantChain = task.exerciseChainInfo.participantExerciseChain;
        if (participantChain.state === 'Completed') {
          const chainReward = task.exerciseChainInfo.reward ?? participantChain.reward;
          const hasReward = chainReward !== undefined && chainReward !== null && Number(chainReward) > 0;
          if (!hasReward) return this.getTaskRewardRange(task);
          return typeof chainReward === 'number' ? chainReward : Math.round(Number(chainReward));
        }
        return this.getTaskRewardRange(task);
      }

      if (task.participantExercise && task.participantExercise.state === 'Completed') {
        const completedReward = task.participantExercise.reward;
        const hasReward = completedReward !== undefined && completedReward !== null && Number(completedReward) > 0;
        if (!hasReward) return this.getTaskRewardRange(task);
        return typeof completedReward === 'number' ? completedReward : Math.round(Number(completedReward));
      }
      return this.getTaskRewardRange(task);
    },
    getCompletedTaskDate(task) {
      if (task.exerciseChainId) {
        const participantChain = task.exerciseChainInfo.participantExerciseChain;
        if (participantChain.state === 'Completed' && participantChain.completedOn) {
          return participantChain.completedOn;
        }
        if (participantChain.state === 'Rejected' && participantChain.rejectedOn) {
          return participantChain.rejectedOn;
        }
        return '';
      }

      if (task.participantExercise && task.participantExercise.completedOn) {
        return task.participantExercise.completedOn;
      }
      return '';
    },
    formatCountdown(seconds) {
      const duration = dayjs.duration(seconds * 1000);
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      if (days >= 1) {
        return `${days}д ${hours}ч`;
      }
      return duration.format('HH:mm:ss');
    },
    setCountdown(date) {
      const value = dayjs.utc(date);
      if (value.isValid()) {
        this.dateValue = value;
        this.updateCountdown();
      }
    },
    updateCountdown() {
      const seconds = this.dateValue.diff(dayjs.utc(), 'seconds');
      if (seconds <= 0) {
        this.countdownText = '00:00:00';
        return;
      }
      this.countdownText = this.formatCountdown(seconds);
      setTimeout(() => { this.updateCountdown(); }, this.isLongCountDown ? 60000 : 1000);
    },
  },
  mounted() {
    this.getProfile();
    this.getBalance();
    this.defineCurrentTab();
    if (this.themeDone) {
      this.setupFiltersAndSorting();
    }
    this.getAmbassadors();
    this.getDisciplines()
      .then(() => {
        this.setDisciplineFilter();
        this.isFiltersLoaded = true;
        this.loadTasks();
      });
    window.addEventListener('hashchange', this.onHashChange);

    // Приоритет hash над query параметром showChain
    // Если hash уже есть, используем его (он сохраняется при перезагрузке)
    // Query параметр showChain используется только если hash отсутствует
    if (window.location.hash && window.location.hash.includes('#!showTask')) {
      // Hash уже есть - он будет обработан после загрузки данных в loadTasks()
      // Не вызываем onHashChange сразу, ждем загрузки данных
      // Удаляем query параметр showChain, если он есть, чтобы избежать конфликтов
      if (this.$route.query.showChain) {
        this.$router.replace({ query: {} }).catch(() => {});
      }
    } else if (this.$route.query.showChain) {
      // Hash нет, но есть query параметр - используем его
      this.exerciseChainId = this.$route.query.showChain;
      setTimeout(() => {
        window.location.hash = `#!showTask=${this.exerciseChainId}`;
        // Удаляем query параметр после установки hash
        this.$router.replace({ query: {} }).catch(() => {});
      }, 1000);
    }
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.onHashChange);
  },
};
</script>

<style lang="scss" scoped>
  @import "./Tasks";
</style>
